import React from 'react'
import map from './images/map.png'

const Record = () => {
    return (
        <>
            <div className="bg-[#ececec]">

                <div class="grid grid-cols-12 py-12 px-6">

                    <div class="md:col-span-6 col-span-12">
                        <div className="">
                            <div className=""><h1 className='md:text-[2.6rem] text-[2rem] text-[#004A8B] high  lg:mx-20'>Track Record</h1></div>
                            <div className=" border-b-[.4rem] border-b-[#B5D1B3] mt-[.6rem] w-[4rem]   lg:mx-[5.5rem]"></div>
                        </div>
                        <div className=""><h1 className='text-[#004A8B] text-[1.1rem]  lg:mx-20 md:text-[1.5rem] high leading-8 my-7 tracking-wide '>The LAWD team has unparalleled valuation, transaction and advisory experience, with the equivalent of centuries of involvement in property across multiple industries, and market knowledge that can only be acquired with time.</h1>
                        </div>

                        <div className="flex py-3 lg:py-5 lg:px-20  ">
                            <button className='border text-[.8rem] text-center border-[#004A8B]  py-3 text-[#004A8B] hover:text-[white] hover:bg-[#004A8B] px-9'>FIND OUT MORE</button>
                        </div>
                    </div>

                    <div class="md:col-span-6 col-span-12 lg:my-0 my-4"><img src={map} alt="" className='md:w-[300px] lg:w-[400px] w-auto h-[400px]' />
                    </div>
                    
                </div>
            </div>
        </>
    )
}

export default Record